import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageGoldCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Gold Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-gold-card.png',
  show: true,
  position: 'right'
};

export const BannerContentGoldCardMocks: GenericLabel = {
  title: 'Delta SkyMiles® Gold Card Member',
  subtitle: ''
};

export const BannerGoldCardMocks: CardCarouselBanner = {
  labels: BannerContentGoldCardMocks,
  image: BannerImageGoldCardMocks
};
